module.exports = __webpack_public_path__ + "b404b4320ea098b41b7d02bcc510704f.pdf";